import { render, staticRenderFns } from "./StudentsByHaStatus.vue?vue&type=template&id=3589b387&scoped=true&"
import script from "./StudentsByHaStatus.vue?vue&type=script&lang=js&"
export * from "./StudentsByHaStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3589b387",
  null
  
)

export default component.exports